import { Component, OnInit } from '@angular/core';
import { ParameterService } from '../../services/parameter.service';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.css']
})
export class TopNavComponent implements OnInit {

  isCollapsed = true;

  constructor(public parameterService: ParameterService, private localization: LocalizationService) { }

  ngOnInit() {
  }

  onSwitchLanguage(lang: string) {
    this.localization.changeLanguage(lang);
  }

}




// WEBPACK FOOTER //
// /home/ubuntu/MembriPay/src/app/components/top-nav/top-nav.component.ts